import { VdsCard } from '@volt/volt-extended-components-react';
import styles from './MetricCard.module.scss';
import Metric, { MetricProps } from '../metric/Metric';
import { To, useNavigate } from 'react-router-dom';

interface MetricCardProps {
  title: string;
  metrics: [MetricProps, MetricProps];
  to?: To;
}

export const MetricCard = ({ title, metrics, to }: MetricCardProps) => {
  const navigate = useNavigate();

  const navigationProps = to
    ? {
        button: true,
        onClick: () => navigate(to),
      }
    : {};

  return (
    <VdsCard className={styles.card} padding="spacing-04" {...navigationProps}>
      <div className={styles.card__slot}>
        <div className={styles.card__title}>{title}</div>
        <div className={styles.card__metrics}>
          <Metric {...metrics[0]} />
          <div className={styles.divider} />
          <Metric {...metrics[1]} />
        </div>
      </div>
    </VdsCard>
  );
};

export default MetricCard;
